import * as React from 'react';
import { Field, ErrorMessage } from 'formik';
import { FormFieldOption } from '../types';
import style from '@magoosh/lib/formik_inputs/field_input/style.module.scss';

interface RadioGroupProps {
  label: string;
  name: string;

  optionsArray: FormFieldOption[];

  selected: string;
  onChange: (newValue: string) => void;
}

export default function RadioGroup(props: RadioGroupProps) {
  return (
    <fieldset className="radio">
      <div className="controls radio_buttons form-group">
        <label className="control-label">{props.label}</label>
        <div>
          {props.optionsArray.map((option) => (
            <div className="radio" key={option.value}>
              <label className="choice">
                <Field
                  component="input"
                  type="radio"
                  name={props.name}
                  value={option.value}
                  checked={props.selected === option.value}
                  onChange={() => props.onChange(option.value)}
                />
                {option.displayName}
              </label>
            </div>
          ))}
        </div>
        <div className={style.errorMessage}>
          <ErrorMessage name={props.name} />
        </div>
      </div>
    </fieldset>
  );
}
